<!-- Carriers List Tab Content -->
<div class="carriers-list-tab-content">
  <!-- Title and Add Button -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h5 class="mb-0">Carriers ({{ filteredCarriers.length }})</h5>
    <button class="btn btn-primary" (click)="openAddCarrierModal()">
      <i class="bi bi-plus-circle me-1"></i>Add Carrier
    </button>
  </div>

  <!-- Carriers Table -->
  <div class="table-responsive">
    <table class="table table-hover align-middle">
      <thead>
        <tr>
          <th>Code</th>
          <th>Name</th>
          <th>Type</th>
          <th>Shipment Modes</th>
          <th>Status</th>
          <th>Created</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let carrier of filteredCarriers">
          <td><strong>{{ carrier.code }}</strong></td>
          <td>{{ carrier.name }}</td>
          <td><span class="badge bg-light text-dark">{{ getCarrierTypeLabel(carrier.carrierType) }}</span></td>
          <td>
            <span *ngIf="!carrier.modes || carrier.modes.length === 0">-</span>
            <span *ngIf="carrier.modes && carrier.modes.length > 0">{{ carrier.modes.join(', ') }}</span>
          </td>
          <td>
            <span class="badge bg-primary" *ngIf="carrier.isActive">Active</span>
            <span class="badge bg-secondary" *ngIf="!carrier.isActive">Inactive</span>
          </td>
          <td>{{ formatDate(carrier.createdAt) }}</td>
          <td>
            <button class="btn btn-sm btn-link p-1" (click)="openEditCarrierModal(carrier)" title="Edit">
              <i class="bi bi-pencil"></i>
            </button>
            <button class="btn btn-sm btn-link text-danger p-1" (click)="deleteCarrier(carrier.id)" title="Delete">
              <i class="bi bi-trash"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="filteredCarriers.length === 0">
          <td colspan="7" class="text-center text-muted py-4">
            <i class="bi bi-inbox me-2"></i>No carriers found
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- Create Carrier Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showAddModal"
     style="z-index: 1060 !important; background-color: rgba(0, 0, 0, 0.9) !important;"
     (click)="closeAddCarrierModal()"></div>
<div class="modal fade show d-block" *ngIf="showAddModal"
     style="z-index: 1061 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Add Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Create Carrier</h5>
        <button type="button" class="btn-close" (click)="closeAddCarrierModal()"></button>
      </div>

      <!-- Add Modal Body -->
      <div class="modal-body">
        <form>
          <!-- Two Column Layout for Name and Code -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="addName" class="form-label">Carrier Name <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="addName"
                [(ngModel)]="formData.name"
                name="name"
                placeholder="e.g. Maersk"
                required
              />
            </div>
            <div class="col-md-3">
              <label for="addCode" class="form-label">Code <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="addCode"
                [(ngModel)]="formData.code"
                name="code"
                placeholder="e.g. MAERSK"
                required
              />
            </div>
            <div class="col-md-3">
              <label for="addCarrierType" class="form-label">Carrier Type</label>
              <select class="form-select" id="addCarrierType" [(ngModel)]="formData.carrierType" name="carrierType">
                <option [ngValue]="undefined">-- Select --</option>
                <option *ngFor="let t of carrierTypes" [ngValue]="t.value">{{ t.label }}</option>
              </select>
            </div>
          </div>

          <!-- Shipment Modes -->
          <div class="mb-3">
            <label class="form-label">Shipment Modes <span class="text-danger">*</span></label>
            <div class="d-flex flex-wrap gap-2">
              <button
                type="button"
                *ngFor="let mode of availableModes"
                class="btn btn-outline-primary mode-pill"
                [class.active]="isModeSelected(mode)"
                (click)="toggleMode(mode)">
                {{ mode }}
              </button>
            </div>
          </div>

          <!-- Regions Served -->
          <div class="mb-3">
            <label class="form-label">Regions Served (Optional)</label>
            <div class="d-flex flex-wrap gap-2 mb-2">
              <button
                type="button"
                *ngFor="let region of availableRegions"
                class="btn btn-outline-secondary region-pill"
                [class.active]="isRegionSelected(region)"
                (click)="toggleRegion(region)">
                {{ region }}
              </button>
            </div>

            <!-- Custom Region Input -->
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Add custom region"
                [(ngModel)]="customRegionInput"
                name="customRegion"
                (keyup.enter)="addCustomRegion()"
              />
              <button class="btn btn-outline-secondary" type="button" (click)="addCustomRegion()">
                Add
              </button>
            </div>

            <!-- Display Selected Custom Regions -->
            <div class="mt-2" *ngIf="formData.regions && formData.regions.length > 0">
              <span class="badge bg-secondary me-1" *ngFor="let region of formData.regions">
                {{ region }}
                <i class="bi bi-x-circle ms-1" style="cursor: pointer;" (click)="toggleRegion(region)"></i>
              </span>
            </div>
          </div>

          <!-- Notes -->
          <div class="mb-3">
            <label for="addNotes" class="form-label">Notes (Optional)</label>
            <textarea
              class="form-control"
              id="addNotes"
              [(ngModel)]="formData.notes"
              name="notes"
              rows="3"
              placeholder="Additional notes about this carrier"></textarea>
          </div>

          <!-- Status Toggle -->
          <div class="mb-3">
            <label class="form-label d-block">Status</label>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="addStatus"
                [(ngModel)]="formData.isActive"
                name="isActive"
              />
              <label class="form-check-label" for="addStatus">
                Enable this carrier for use in the system
              </label>
            </div>
          </div>
        </form>
      </div>

      <!-- Add Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAddCarrierModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createCarrier()">Create Carrier</button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Carrier Modal (Nested) -->
<div class="modal-backdrop fade show" *ngIf="showEditModal"
     style="z-index: 1060 !important; background-color: rgba(0, 0, 0, 0.9) !important;"
     (click)="closeEditCarrierModal()"></div>
<div class="modal fade show d-block" *ngIf="showEditModal"
     style="z-index: 1061 !important;"
     tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">
      <!-- Edit Modal Header -->
      <div class="modal-header">
        <h5 class="modal-title">Edit Carrier</h5>
        <button type="button" class="btn-close" (click)="closeEditCarrierModal()"></button>
      </div>

      <!-- Edit Modal Body -->
      <div class="modal-body">
        <form>
          <!-- Two Column Layout for Name, Code, Type -->
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="editName" class="form-label">Carrier Name <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="editName"
                [(ngModel)]="editFormData.name"
                name="editName"
                required
              />
            </div>
            <div class="col-md-3">
              <label for="editCode" class="form-label">Code <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control"
                id="editCode"
                [(ngModel)]="editFormData.code"
                name="editCode"
                required
              />
            </div>
            <div class="col-md-3">
              <label for="editCarrierType" class="form-label">Carrier Type</label>
              <select class="form-select" id="editCarrierType" [(ngModel)]="editFormData.carrierType" name="editCarrierType">
                <option [ngValue]="undefined">-- Select --</option>
                <option *ngFor="let t of carrierTypes" [ngValue]="t.value">{{ t.label }}</option>
              </select>
            </div>
          </div>

          <!-- Shipment Modes -->
          <div class="mb-3">
            <label class="form-label">Shipment Modes <span class="text-danger">*</span></label>
            <div class="d-flex flex-wrap gap-2">
              <button
                type="button"
                *ngFor="let mode of availableModes"
                class="btn btn-outline-primary mode-pill"
                [class.active]="isModeSelected(mode, true)"
                (click)="toggleMode(mode, true)">
                {{ mode }}
              </button>
            </div>
          </div>

          <!-- Regions Served -->
          <div class="mb-3">
            <label class="form-label">Regions Served (Optional)</label>
            <div class="d-flex flex-wrap gap-2 mb-2">
              <button
                type="button"
                *ngFor="let region of availableRegions"
                class="btn btn-outline-secondary region-pill"
                [class.active]="isRegionSelected(region, true)"
                (click)="toggleRegion(region, true)">
                {{ region }}
              </button>
            </div>

            <!-- Custom Region Input -->
            <div class="input-group">
              <input
                type="text"
                class="form-control"
                placeholder="Add custom region"
                [(ngModel)]="customRegionInput"
                name="customRegionEdit"
                (keyup.enter)="addCustomRegion(true)"
              />
              <button class="btn btn-outline-secondary" type="button" (click)="addCustomRegion(true)">
                Add
              </button>
            </div>

            <!-- Display Selected Custom Regions -->
            <div class="mt-2" *ngIf="editFormData.regions && editFormData.regions.length > 0">
              <span class="badge bg-secondary me-1" *ngFor="let region of editFormData.regions">
                {{ region }}
                <i class="bi bi-x-circle ms-1" style="cursor: pointer;" (click)="toggleRegion(region, true)"></i>
              </span>
            </div>
          </div>

          <!-- Notes -->
          <div class="mb-3">
            <label for="editNotes" class="form-label">Notes (Optional)</label>
            <textarea
              class="form-control"
              id="editNotes"
              [(ngModel)]="editFormData.notes"
              name="editNotes"
              rows="3"
              placeholder="Additional notes about this carrier"></textarea>
          </div>

          <!-- Status Toggle -->
          <div class="mb-3">
            <label class="form-label d-block">Status</label>
            <div class="form-check form-switch">
              <input
                class="form-check-input"
                type="checkbox"
                id="editStatus"
                [(ngModel)]="editFormData.isActive"
                name="editIsActive"
              />
              <label class="form-check-label" for="editStatus">
                Enable this carrier for use in the system
              </label>
            </div>
          </div>
        </form>
      </div>

      <!-- Edit Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeEditCarrierModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="updateCarrier()">Save Changes</button>
      </div>
    </div>
  </div>
</div>
